export default __webpack_public_path__ + "static/media/3e6676e0986ec757.69c104c584875251aad17536815e7881.svg";